export const filterDateTypeOptions = [
    { label: "Data de criação", value: "CREATED_DATE" },
    { label: "Data de entrada", value: "ENTRY_DATE" }
]